const config = {
  RECAPTCHA_SITE_KEY_SINGUP: "6LeEj5EiAAAAALqmBik-Mh0VDFJsJtiRUbpn_H7I",
  RECAPTCHA_SITE_KEY: "6Lc9l-8lAAAAAGu3OC345SzOim4eRIww5TYxSkPm",
  CLIENT_JOB_MIN_DEADLINE: process.env.REACT_APP_CLIENT_JOB_MIN_DEADLINE || 1,
  APP_ENV: process.env.REACT_APP_ENV,
  WEB_URL: process.env.REACT_APP_WEB_URL,
};
// test
export default config;
